<template>
  <div class="login">
    <div class="container">
      <div class="flex justify-center">
        <div class="w-full max-w-md mx-auto">
          <div class="card">
            <div class="p-12">
              <div class="mb-6 text-2xl font-bold">
                Login to your account
              </div>
              <div class="px-4 py-2 mb-3 text-red-700 bg-red-200 rounded-md" v-if="form_errors.length">
                <div v-for="error in form_errors" :key="error.message">
                  {{ error.message }}
                </div>
              </div>
              <form @submit.prevent="login()" :disabled="submitting">
                <fieldset class="form-group">
                  <label class="form-label">Email Address</label>
                  <input id="email" class="py-3 form-input" type="email" tabindex="1" placeholder="Email Address" v-model="form.email" required autofocus>
                  <validations :errors="errors" field="email" />
                </fieldset>
                <fieldset class="form-group">
                  <label class="items-center justify-between form-label">
                    Password 
                    <a class="text-xs font-medium tracking-wide uppercase text-primary hover:underline" href="#" @click="showPassword = !showPassword" tabindex="3">
                      {{ showPassword ? 'Hide' : 'Show' }} Password
                    </a>
                  </label>
                  <input id="password" class="py-3 form-input" :type="showPassword ? 'text' : 'password'" tabindex="2" placeholder="Password" v-model="form.password" required>
                  <validations :errors="errors" field="password" />
                </fieldset>
                <button type="submit" class="w-full btn btn-lg btn-primary" v-submitting="submitting">
                  Login
                </button>
                <router-link :to="{ name: 'ForgotPassword', query: { email: form.email.toLowerCase() } }" class="block mt-6 text-center">Forgot password?</router-link>
              </form>
            </div>
          </div>
          <div class="my-8 text-center">
            Don't have an account yet? <router-link :to="{ name: 'Register' }">Start Your Free Trial</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Login',

    metaInfo: {
      title: 'Login'
    },

    data () {
      return {
        submitting: false,
        showPassword: false,
        form_errors: [],
        errors: [],
        form: {
          email: '',
          password: ''
        }
      }
    },

    methods: {
      async login () {
        try {
          this.submitting = true
          const { data } = await this.$api.post('auth/login', this.form)
          this.$cookies.remove('customer_token')
          this.$cookies.set('token', data.token.token)
          await this.$store.dispatch('syncUser', this)

          if (this.$route.query.redirect) {
            window.location.href = this.$route.query.redirect
          } else {
            this.$router.push({ name: 'Dashboard', params: { account: this.$store.getters.account.subdomain } })
          }
        } catch (error) {
          console.error(error)
          this.errors = error.response.data.errors ? error.response.data.errors : []
          this.form_errors = error.response.data.form_errors ? error.response.data.form_errors : []
          this.$toasted.error(error.response.data.message)
        } finally { 
          this.submitting = false
        }
      }
    }

  }
</script>